
import { getLoadTransferSurface } from '@/modules/storm'
import { latex_units, roundToTwoDigits } from '@/services/unit.service'
import { modelViewerStore } from '@/store/modelViewer.store'
import { LoadTransferSurface } from '@consteel/storm'
import Vue from 'vue'
import InfoTable from './InfoTable.vue'
import { TableNode } from './TableNode'

export default Vue.extend({
  name: 'LoadTransferSurfaceTable',
  components: {
    InfoTable,
  },
  props: {
    compare: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    primaryMember(): LoadTransferSurface | null {
      if (!modelViewerStore.model.rawSmadsteelModel) return null

      return getLoadTransferSurface(
        modelViewerStore.model.rawSmadsteelModel,
        modelViewerStore.selectedIds[0]
      )
    },
    secondaryMember(): LoadTransferSurface | null {
      if (!this.compare || !modelViewerStore.secondaryModel.rawSmadsteelModel) return null

      return getLoadTransferSurface(
        modelViewerStore.secondaryModel.rawSmadsteelModel,
        modelViewerStore.selectedIds[0],
        true
      )
    },
    primaryItems(): TableNode[] {
      return this.getTableItemsFromModelItem(this.primaryMember)
    },

    secondaryItems(): TableNode[] {
      return this.getTableItemsFromModelItem(this.secondaryMember)
    },
  },
  methods: {
    getTableItemsFromModelItem(item: LoadTransferSurface | null): TableNode[] {
      if (!item) return []

      return [
        {
          name: this.$t('Name'),
          value: item.name,
        },
        {
          name: this.$t('Distribution method'),
          value: item.distributionMethod,
        },
        {
          name: this.$t('Member selection'),
          value: item.memberSelection,
        },
        {
          name: this.$t('Load eccentricity Z'),
          value: roundToTwoDigits(item.eccentricity?.z),
          unit: latex_units.mm,
        },
      ]
    },
  },
})
